import { render } from "./SurveyPage.vue?vue&type=template&id=e0d032cc&scoped=true"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"

import "./SurveyPage.vue?vue&type=style&index=0&id=e0d032cc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d032cc"]])

export default __exports__